module.exports = __webpack_public_path__ + "img/Woman-8.5867cb16.svg";